import { useParams, useSearchParams } from "react-router-dom";
import { ROOT_SLUG } from "../const/enviroment";
import { useLocalStorage } from "./useLocalStorage.ts";
import { ItemStatusType } from "../types/Item.ts";

export const useActiveParams = (
  userId?: string,
  pageSizeCustom?: number,
  status?: ItemStatusType,
) => {
  const [searchParams] = useSearchParams();
  const { category } = useParams<{ category: string }>();
  const pageSize = useLocalStorage("pageSize", "12");

  return {
    categorySlug: category || ROOT_SLUG,
    page: Number(searchParams.get("page") || "0"),
    pageSize: pageSizeCustom || Number(pageSize),
    filter: searchParams.getAll("filter").join(",") || "",
    sortBy: searchParams.get("sort") || "",
    sortOrder: searchParams.get("order") || "",
    user: userId || searchParams.get("user") || "",
    status: status || ((searchParams.get("status") || "") as ItemStatusType),
    search: searchParams.get("search") || "",
  };
};
